import { produce, Draft } from 'immer'
import { createSelector } from 'reselect';
import { RootState } from '.';
import { ID } from '../common/types';

import { BookingFolder } from '../common/types/booking';
import { bookingAddedSupplements } from "./supplement";

type SelectedBooking = {
  id?: ID
  cancellationConditionId?: ID
  index?: number
}


type State = {
  bookings: any
  bookingsByStatus: {}
  isBookerPax: any
  bookingFolder: BookingFolder
  bookingCancel: any
  selectedBooking: SelectedBooking
  bookingsCompletionRates: any
}

const booking = {
  state: {
    bookings: [],
    bookingsByStatus: {},
    isBookerPax: [],
    bookingFolder: {},
    bookingCancel: {},
    selectedBooking: {
      id: 0,
      cancellationConditionId: 0,
      index: 0
    },
    bookingsCompletionRates: {}
  } as State,
  reducers: {
    load: produce((draft: Draft<State>, payload: Partial<State>) => {
      Object.assign(draft, payload)
      if (payload?.bookings) {
        draft.bookingsByStatus = getBookingsByStatus(payload.bookings);
      }
      
    }),
    updateSelectedBooking: produce((draft: Draft<State>, payload: SelectedBooking) => {
      Object.assign(draft.selectedBooking, payload)
    }),
    updateBookings: produce((draft: Draft<State>, payload: { data: Object }) => {
      const bookings = createBookingsData(payload.data)
      draft.bookings = bookings
    }),
    updateIsBookerPax: produce((draft: Draft<State>, payload: { data: Object }) => {
      let tempData = [];
      for (let currentBookingId in payload) {
        tempData.push({
          bookingId: currentBookingId,
          isBookerPax: payload[currentBookingId]
        })
      }
      draft.isBookerPax = payload;
    }),
    updateBookingByIndex: produce((draft: Draft<State>, payload: { bookingIndex: number, booking: any }) => {
      if (draft.bookings[payload.bookingIndex]) {
        Object.assign(draft.bookings[payload.bookingIndex], payload.booking)
      }

      draft.bookingsByStatus = getBookingsByStatus(draft.bookings);

    })
  },
  effects: (dispatch) => ({
    loadBookingFolderInformations() {
      //dispatch.
    },
    async updateBookingsAsync(payload, rootState) {
      payload.data.rateplanServices = rootState.rateplan.rateplanServicesList
      dispatch.booking.updateBookings(payload)
    },
    async updateBookingsCompletionRateAsync(payload) {
      dispatch.booking.load(payload.bookingsCompletionRates);

      if (payload.isFromSelfCheckin && payload.bookingsCompletionRates.bookingsCompletionRates[payload.currentBookingId]?.rate === 100) {
        dispatch.modal.handleModal({successSelfCheckinModal: true})
      }
    }
  })
}

const getBookingsByStatus = (bookings) => {
  const cancelledBookings = [];
  const noCancelledBookings = [];
  bookings.forEach(booking => {
    if (booking.status !== 'cancel') {
      noCancelledBookings.push(booking);
    } else {
      cancelledBookings.push(booking);
    }
  })

  return {
    noCancelledBookings: noCancelledBookings,
    cancelledBookings: cancelledBookings
  }
}

export const createBookingsData = (data) => {
  const bookingsTab = [];
  const bookings = [...data.bookings];

  if (bookings && bookings.length > 0) {
    bookings.forEach((booking) => {
      if (data.bookingAccommodations) {
        booking.bookingAccommodation = data?.bookingAccommodations.filter(
          (accommodation) => parseInt(accommodation.bookingId) === booking.id
        );
      }

      if (data.bookingOptions) {
        booking.bookingOptions = data.bookingOptions.filter(
          (option) => parseInt(option.bookingId) === booking.id
        );
      }

      if (data.bookingExtras) {
        booking.bookingExtras = data.bookingExtras.filter(
          (extra) => parseInt(extra.bookingId) === booking.id
        );
      }

      if (data.rateplanServices) {
        booking.rateplanServices = data.rateplanServices.filter(
          (service) => service.rateplanId === booking.rateplanId
        );
      }

      bookingsTab.push(booking);
    });
  }

  bookingsTab.sort((a, b) => {
    if (a.status === 'future' && b.status === 'active') {
      return 1
    }
    if (a.status === 'cancel' && b.status === 'active') {
      return 0
    }
    return -1
  })

  return bookingsTab;
}

const bookingsSelector = (state: RootState) => state.booking.bookings

export const totalBookingAccommodationPrice = createSelector(
  [bookingsSelector],
  (bookings) => {
    let pricePerBooking = {};

    pricePerBooking = bookings.reduce((acc, booking) => {
      /*const accommodationPrice = booking?.bookingAccommodation?.reduce(
        (acc, val) => {
          return acc + parseFloat(val.totalAmount);
        },
        0
      );*/

      const accommodationPrice = booking?.accommodationPriceTotal;

      return { ...acc, [booking.id]: accommodationPrice };
    }, {});

    return pricePerBooking;
  }
);

export const totalBookingsPrice = createSelector(
  [bookingsSelector, bookingAddedSupplements, totalBookingAccommodationPrice],
  (bookings, supplements, totalAccommodation) => {
    const prices = {};

    bookings.forEach((booking) => {

      let price = 0;
      // note secondaire
      if (booking?.hasNoteSecondary == 1) {
        supplements[booking.id].list.forEach((supplement) => {
          if (supplement.isNote) {
            price = price + supplement.totalAmount
          }
        })
      }
      else{

        price = supplements[booking.id].totalPrice + totalAccommodation[booking.id];

        if (booking.correctionTarif !== 0) {
          price = price + booking.correctionTarif;
        }

        if (booking.totalRemise !== 0) {
          price = price - booking.totalRemise;
        }
      }


      prices[booking.id] = price;
    });

    return prices;
  }
);

export const totalBookingFolderPrice = createSelector(
  [totalBookingsPrice],
  (bookingsPrice) => {
    return Object.keys(bookingsPrice).reduce((acc, bookingId) => {

      return acc + bookingsPrice[bookingId];
    }, 0);
  }
);

export default booking
